import { QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { I18nProvider } from 'react-aria'
import { createBrowserRouter, Navigate, Outlet, RouterProvider } from 'react-router-dom'
import { AccountPermissionsProvider } from './account-permissions'
import { CLIENTS_ROUTES } from './clients/routes'
import { DASHBOARD_ROUTES } from './dashboard/routes'
import { HOME_ROUTES } from './home/routes'
import { IgnoreRentnerProvider } from './ignore-rentner'
import { OBJECTS_ROUTES } from './objects/routes'
import { PROPOSALS_ROUTES } from './proposals/routes'
import { queryClient } from './query-client'
import { REPORTING_ROUTES } from './reporting/routes'
import { RESERVATIONS_ROUTES } from './reservations/routes'
import { Root } from './root'
import { SETTINGS_ROUTES } from './settings/routes'
import 'react-toastify/dist/ReactToastify.css'

const router = createBrowserRouter([
	{
		path: '/*',
		element: <Root />,
		children: [
			{
				path: '',
				element: <Navigate to="svc" replace />,
			},
			{
				path: 'svc',
				element: <Outlet />,
				children: [
					HOME_ROUTES,
					DASHBOARD_ROUTES,
					CLIENTS_ROUTES,
					PROPOSALS_ROUTES,
					RESERVATIONS_ROUTES,
					REPORTING_ROUTES,
					OBJECTS_ROUTES,
				],
			},
			{
				path: 'stp',
				element: <Outlet />,
				children: [SETTINGS_ROUTES],
			},
		],
	},
])

export function App() {
	return (
		<StrictMode>
			<I18nProvider locale="cs">
				<QueryClientProvider client={queryClient}>
					<AccountPermissionsProvider>
						<IgnoreRentnerProvider>
							<RouterProvider router={router} />
						</IgnoreRentnerProvider>
					</AccountPermissionsProvider>
				</QueryClientProvider>
			</I18nProvider>
			<form id="none" />
		</StrictMode>
	)
}
